<script setup>
import { onUnmounted, ref } from 'vue'
import AppLayout from '@/Layouts/AppLayout.vue'
import Feed from '@/Shared/Feed.vue'
import { Link, usePage } from '@inertiajs/vue3'
import { usePostStore } from '@/Stores/PostStore'
import { useVideoStore } from '@/Stores/VideoStore'
import { useAdStore } from '@/Stores/AdStore'
import { useAdSenseNavigation } from '@/Composables/useAdSenseNavigation'
import { SignalIcon } from '@heroicons/vue/24/outline/index.js'

const props = defineProps({
	posts: Object, // Now a paginated object from Inertia::scroll()
});

const settings = ref(usePage().props.settings)
const postStore = usePostStore()
const videoStore = useVideoStore()
const adStore = useAdStore()
const { onPostActive } = useAdSenseNavigation()

onUnmounted(() => {
	postStore.$dispose()
	videoStore.$dispose()
})
</script>

<template>
	<AppLayout>
		<div v-if="!adStore.isShow"
		     class="absolute z-20 w-full pointer-events-none">

			<!-- Top gradient overlay -->
			<div class="bg-gradient-to-b from-black/25 via-black/10 via-black/5 to-transparent min-h-[200px] pointer-events-none"></div>

			<!-- Logo and controls positioned over gradient -->
			<div class="absolute top-0 left-0 right-0 md:p-8 p-4 flex font-bold items-center justify-between text-white pointer-events-auto">
				<img v-if="settings.general.logo" :src="settings.general.logo" alt="" class="h-8"/>

				<Link v-if="settings.live_models_feed_enabled" :href="route('live')"
				      class="text-white flex flex-col items-center justify-center space-y-0.5 hover:bg-white hover:bg-opacity-30 rounded-full w-12 h-12">
					<SignalIcon class="h-5"/>
					<span class="bg-white rounded text-[6pt] text-black px-0.5">Live</span>
				</Link>
			</div>
		</div>

		<Feed :posts="posts" :preserve-url="true" @post-active="onPostActive" />
	</AppLayout>
</template>

